export const IssueTypeSortCategories = [
    {
        value: 0,
        description: "Not Set"
    },
    {
        value: 1,
        description: "Excess"
    },
    {
        value: 2,
        description: "Reconciliation"
    },
    {
        value: 3,
        description: "Clarification"
    },
    {
        value: 4,
        description: "Bank Expenditure Clarification"
    },
    {
        value: 5,
        description: "General"
    },
    {
        value: 6,
        description: "Missing Auxiliary Reports"
    },
    {
        value: 7,
        description: "Occupation / Employer"
    },
    {
        value: 8,
        description: " No Response Required"
    }
]

export default IssueTypeSortCategories